import { inject, Injectable } from '@angular/core';
import { ServicesService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class ManagementEndpointService {
  readonly #service = inject(ServicesService);

  resultFromArrangementByActor(actorId: string, arrangementCode: string) {
    return this.#service.thor(
      `management/result/actor/${actorId}/arrangement/${arrangementCode}`,
    );
  }

  statisticsByActor(actorId: string) {
    return this.#service.thor(`management/result/actor/${actorId}/statistics`);
  }

  mergeActorResults(
    formerActorId: string,
    targetActorId: string,
    arrangementCode?: string,
  ) {
    return arrangementCode
      ? this.#service.thor(
          `management/result/actor/merge/${formerActorId}/${targetActorId}/${arrangementCode}`,
        )
      : this.#service.thor(
          `management/result/actor/merge/${formerActorId}/${targetActorId}`,
        );
  }

  mergeConflicts(
    formerActorId: string,
    targetActorId: string,
    arrangementCode?: string,
  ) {
    return arrangementCode
      ? this.#service.thor(
          `management/result/actor/merge/conflicts/${formerActorId}/${targetActorId}/${arrangementCode}`,
        )
      : this.#service.thor(
          `management/result/actor/merge/conflicts/${formerActorId}/${targetActorId}`,
        );
  }
}
